"use client";
import React from "react";

import Button from "components/common/button";

import IconInfo from "assets/svg/info.svg";

import styles from "./styles.module.css";

const NoResults = () => {
  const handleDeleteAllButton = async () => {
    window.location.href = "/proje-radari";
  };

  return (
    <div>
      <div className={styles.wrapper}>
        <div className={styles.icon}>
          <IconInfo width="19" height="19" />
        </div>
        <div className={styles.infoWrapper}>
          <span className={styles.title}>Sonuç Bulunamadı.</span>
          <p className={styles.info}>
            Aramanıza uygun proje bulunamadı. Arama Kriterlerinizi değiştirerek tekrar deneyebilirsiniz
          </p>
          <div className={styles.buttonWrapper}>
            <div className={styles.button}>
              <Button onClick={handleDeleteAllButton} size="M">
                Filtreyi Temizle
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.space}></div>
    </div>
  );
};
export default NoResults;
